module.exports = __webpack_public_path__ + "img/week-tab-2.f1848a83.png";